/** Generic horizontal carousel: arrow buttons scroll one item; buttons disable at the ends. */
if (!customElements.get('pro-carousel')) {
  class ProCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));
      this.onScroll = () => this.updateButtons();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.track);
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-carousel-item]');
        if (item) this.track.scrollTo({ left: item.offsetLeft, behavior: "smooth" });
      });
      this.updateButtons();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    step(direction) {
      const item = this.track.querySelector('[data-carousel-item]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const width = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      this.track.scrollBy({ left: width * direction, behavior: 'smooth' });
    }

    updateButtons() {
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      this.toggleAttribute('data-scrollable', max > 0);
    }
  }

  customElements.define('pro-carousel', ProCarousel);
}
